import { useEffect } from 'react';
import { BaseUser } from 'v2/core/entities/user';
import useGetTenantListFromEdgeServer from 'v2/core/repository/edge-server/listTenants';

const useGetTenantList = (user?: BaseUser) => {
  const { data, loading, error, fetchMore, isLoadingMore, hasMore } =
    useGetTenantListFromEdgeServer({ user: user });

  useEffect(() => {
    if (loading || isLoadingMore || !hasMore) {
      return;
    }
    fetchMore();
  }, [fetchMore, hasMore, isLoadingMore, loading]);

  return {
    data,
    loading: isLoadingMore || loading || hasMore,
    error,
  };
};

export default useGetTenantList;
